import React, { useEffect, useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { CircleAlert } from 'lucide-react';
import { useRequestApproveMutation } from './emailApi';

const ApproveModal = ({ patientuniquecode, newemail, setLoading }) => {
    const { t, i18n } = useTranslation();
    const [modalActive, setModalActive] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [status, setStatus] = useState('');
    const [approveRequest] = useRequestApproveMutation();

    const handleSubmit = async () => {
        setButtonLoading(true);

        try {
            const { data } = await approveRequest({
                patientuniquecode,
                newemail,
                status,
            });
            if (data) {
                setButtonLoading(false);
                setLoading(true);
            }
        } catch (error) {
            setButtonLoading(false);
        }
    };

    return (
        <>
            <Button
                variant="outline-success"
                onClick={() => {
                    setModalActive(true);
                    setStatus('Approve');
                }}
            >
                Approuver
            </Button>
            <Button
                variant="outline-danger"
                onClick={() => {
                    setModalActive(true);
                    setStatus('Decline');
                }}
            >
                Refuser
            </Button>
            <Modal show={modalActive} backdrop="static" keyboard={false}>
                <Modal.Body className="text-center">
                    <CircleAlert
                        size={60}
                        className="mb-4 mt-4"
                        color="#f8bb86"
                    />
                    <p>{t('areYouSure')}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setModalActive(false)}
                    >
                        {t('okay')}
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={buttonLoading}
                    >
                        {buttonLoading && (
                            <Spinner animation="border" role="status" size="sm">
                                <span className="visually-hidden">
                                    Loading...
                                </span>
                            </Spinner>
                        )}{' '}
                        {t('submitRequest')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ApproveModal;
